// extracted by mini-css-extract-plugin
module.exports = {"cross":"Cross_cross___MfjE","openedMenu":"Cross_openedMenu__YYdjB"};